import { useEffect, useState } from "react";

const Index = () => {

  const [online, setOnline] = useState(true);

  const handler = () => {}

  useEffect(() => {

    window.addEventListener('online', () => setOnline(true));
    window.addEventListener('offline', () => setOnline(false));

    return ()=> {
      window.removeEventListener('online', handler);
      window.removeEventListener('offline', handler);
    }
  }, []);

  if (online) return null;

  return (
    <div className="alert alert-danger z-3 text-center fixed-bottom mx-2 my-2">
      <small>você está offline</small>
    </div>
  );
};

export default Index;